import { baseApi } from '@/services'
import { Dscr } from '@/types/unlock'

const dscrApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDscr: builder.query<Dscr, string>({
      query: (applicationUUID) => `v2/applications/${applicationUUID}/dscr/`,
      providesTags: ['Dscr'],
    }),
    createDscr: builder.mutation<Dscr, Partial<Dscr>>({
      query: (dscr) => ({
        url: `v2/dscr/`,
        method: 'POST',
        body: dscr,
      }),
      invalidatesTags: [
        'Dscr',
        'Override',
        'ApplicationCalcs',
        'AutomatedApplicationExceptions',
        'Alert',
      ],
    }),
    updateDscr: builder.mutation<Dscr, Partial<Dscr>>({
      query: (dscr) => ({
        url: `v2/dscr/${dscr.uuid}/`,
        method: 'PATCH',
        body: dscr,
      }),
      invalidatesTags: [
        'Dscr',
        'Override',
        'ApplicationCalcs',
        'AutomatedApplicationExceptions',
        'Alert',
      ],
    }),
    updateOrCreateDscr: builder.mutation<Dscr, Partial<Dscr>>({
      query: (dscr) => {
        const url = dscr?.uuid ? `v2/dscr/${dscr.uuid}/` : 'v2/dscr/'
        const method = dscr?.uuid ? 'PATCH' : 'POST'
        return {
          url,
          method,
          body: dscr,
        }
      },
      invalidatesTags: [
        'Dscr',
        'Override',
        'ApplicationCalcs',
        'AutomatedApplicationExceptions',
        'Alert',
      ],
    }),
  }),
})

export const {
  useGetDscrQuery,
  useCreateDscrMutation,
  useUpdateDscrMutation,
  useUpdateOrCreateDscrMutation,
} = dscrApi
